import { ComponentsOverrides, ComponentsProps, ComponentsVariants, CssVarsTheme } from '@mui/material/styles';

export const MuiButton: {
  defaultProps?: ComponentsProps['MuiButton'];
  styleOverrides?: ComponentsOverrides<CssVarsTheme>['MuiButton'];
  variants?: ComponentsVariants<CssVarsTheme>['MuiButton'];
} = {
  styleOverrides: {
    root: ({ theme, ownerState: { variant } }) => ({
      borderRadius: '8px',
      padding: theme.spacing(0, 2),
      textTransform: 'none',
      color: variant === 'text' ? undefined : theme.vars.palette.common.white
    }),
    sizeSmall: ({ theme }) => ({
      borderRadius: '6px',
      height: '32px',
      padding: theme.spacing(0, 1.5)
    }),
    sizeMedium: {
      height: '40px'
    },
    sizeLarge: {
      height: '48px'
    },
    startIcon: ({ theme }) => ({
      marginRight: theme.spacing(1)
    }),
    endIcon: ({ theme }) => ({
      marginLeft: theme.spacing(1)
    }),
    outlined: ({ theme, ownerState }) => ({
      color: ownerState.color ? theme.vars.palette[ownerState.color].main : theme.vars.palette.primary.main
    })
  },
  defaultProps: {
    variant: 'contained',
    disableElevation: true
  },
  variants: [
    {
      props: { color: 'neutral', variant: 'contained' },
      style: ({ theme }) => ({
        color: '#fff',
        backgroundColor: theme.vars.palette.neutral.light
      })
    }
  ]
};
